import { StyleSheet } from 'react-native';

import { commonButtonRow } from '../common';
import { colors, spacing, layout } from '../theme';

export const buttonStyles = StyleSheet.create({
	// Base button styles
	button: {
		maxWidth: 200,
		borderRadius: layout.borderRadius.small,
		paddingVertical: 0,
		paddingHorizontal: 10,
	},

	// Button container for multiple buttons
	buttonContainer: {
		...commonButtonRow, // Shared button row style
	},

	// Button with flex for row layouts
	buttonFlex: {
		flex: 1,
		marginHorizontal: spacing.s,
	},

	// FAB styling
	fab: {
		position: 'absolute',
		margin: spacing.m,
		right: 0,
		bottom: 5,
	},

	// FAB text style
	fabText: {
		fontSize: 24,
		color: 'white',
	},

	// Color styles
	danger: {
		backgroundColor: colors.error,
		color: colors.textWhite,
	},
	success: {
		backgroundColor: colors.success,
		color: colors.textWhite,
	},

	dangerText: {
		color: colors.textWhite,
	},
});
